import PropTypes from 'prop-types';
import { Component } from 'react';

class GenericContent extends Component {
  openStepsMenu = (event) => {
    this.props.openStepsMenu(event);
  };

  toPrevContent = () => {
    const newIndex = this.props.contentIndex - 1;
    if (newIndex > -1) {
      this.props.setContentIndex(newIndex);
    }
  };

  toNextContent = () => {
    const newIndex = this.props.contentIndex + 1;
    if (newIndex < this.props.totalContents) {
      this.props.setContentIndex(newIndex);
    }
  };

  goToContent = (index) => {
    if (
      index !== this.props.contentIndex &&
      index >= 0 &&
      index < this.props.totalContents - 1
    ) {
      this.props.setContentIndex(index);
    }
  };

  render() {
    return <></>;
  }
}

GenericContent.propTypes = {
  contentIndex: PropTypes.number.isRequired,
  totalContents: PropTypes.number.isRequired,
  openStepsMenu: PropTypes.func.isRequired,
  setContentIndex: PropTypes.func.isRequired,
};

export default GenericContent;
